import { createContext, useState } from 'react'

const InputsContext = createContext([{}, () => {}]) 

const ZoneCalculatorProvider = ({ children, initialService }) => {
    const [serviceType, setService] = useState(initialService)
    const [sendFrom, setSendFrom] = useState()
    const [sendTo, setSendTo] = useState()
    const [currentSendFrom, setCurrentSendFrom] = useState()
    const [currentSendTo, setCurrentSendTo] = useState()
    const [errorInputPostalCodeFrom, setErrorInputPostalCodeFrom] = useState(null)
    const [errorInputPostalCodeTo, setErrorInputPostalCodeTo] = useState(null)

    const [apiInvalidArgFields, setApiInvalidArgFields] = useState()
    const [zoneCount, setZoneCount] = useState(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
 
    return (
        <InputsContext.Provider value={{
            serviceType, setService,
            sendFrom, setSendFrom,
            sendTo, setSendTo,
            currentSendFrom, setCurrentSendFrom,
            currentSendTo, setCurrentSendTo,
            errorInputPostalCodeFrom, setErrorInputPostalCodeFrom,
            errorInputPostalCodeTo, setErrorInputPostalCodeTo,
            apiInvalidArgFields, setApiInvalidArgFields,
            zoneCount, setZoneCount,
            loading, setLoading,
            error, setError
        }}>
        {children}
        </InputsContext.Provider>
    )
}

export { InputsContext, ZoneCalculatorProvider }
